import { FormValues } from './FormValues';

export const defaultFormValues: FormValues = {
  id: '',
  member_id: '',
  first_name: '',
  last_name: '',
  can_be_scheduled: true,
  license_number: '',
  license_dob: '',
  license_state: '',
  license_expiration_date: '',
  can_do_wheelchair_service: true,
  can_do_stretcher_service: true,
  can_do_ambulatory_service: true,
  can_do_broda_chair_service: true,
  can_do_geri_chair_service: true,
  can_do_curb_to_curb: true,
  can_do_door_to_door: true,
  can_do_door_through_door: true,
  can_do_bariatric: false,
  can_do_stairs: false,
  can_do_person_to_person: false,
  can_do_student_transport: false,
  allowed_payer_ids: [],
};
